import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';

export const cardStyles = css`
  display: flex;
  flex-direction: column;
  color: ${token('color.text', '#b6c2cf')};
  margin: 5px 0px;
  padding: 12px;
  border-radius: 4px;
  background: ${token('elevation.surface.raised', '#22272B')};
  box-shadow: ${token(
    'elevation.shadow.raised',
    '0 1px 1px rgba(23,43,77,0.2),0 0 1px rgba(23,43,77,0.2)'
  )};
  gap: 8px;

  .label-container {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.42857143;
    width: 90%;
  }

  .epic-link-row {
    display: flex;
    flex-direction: row;
  }

  .epic-link-container {
    padding: 2px;
    border-radius: 5px;
    text-transform: uppercase;
    width: auto;
  }

  .issue-type-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
  }

  .issue-text {
    text-transform: uppercase;
    margin-left: 4px;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px; /* 145.455% */
  }

  .type-priority-assignee-row {
    display: flex;
    flex-direction: row;
  }

  .priority-assignee-container {
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin-left: auto;
  }
`;
